import {
  Alert,
  Button,
  Grid,
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ModalConfirmation from "./ModalConfirmation";
import CreateUserModal from "./CreateUserModal";
import { IUser } from "../interfaces";

const UserTable = ({ users }: { users?: IUser[] }) => {
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({} as IUser);
  const [openModal, setOpenModal] = useState(
    {} as { show: boolean; type: "delete" | "disable" | "" }
  );

  const handleCreate = () => setOpen(true);

  const handleShowConfirmation = (
    user: IUser,
    type: "delete" | "disable" | ""
  ) => {
    setSelectedUser(user);
    setOpenModal({ show: true, type });
  };

  const handleClose = () => {
    setOpenModal({ show: false, type: "" });
    setOpen(false);
    setSelectedUser({} as IUser);
  };

  const handleDelete = (id: string) => {
    console.log("handle delete");
  };

  const handleSwitchCategory = (id: string) => {
    console.log("handle switch");
    handleClose();
  };
  const handleSubmit = () => {
    switch (openModal.type) {
      case "delete":
        return handleDelete(selectedUser.uid);
      case "disable":
        return handleSwitchCategory(selectedUser.uid);
      default:
        return null;
    }
  };

  return (
    <Grid container spacing={2} size={{ xs: 12 }} mt={3} alignItems="center">
      <Grid size={6}>
        <Typography>Personal del negocio</Typography>
      </Grid>
      <Grid size={6} display="flex" justifyContent="end">
        <Button
          size="small"
          variant="contained"
          color="secondary"
          onClick={handleCreate}
        >
          Crear nuevo usuario
        </Button>
      </Grid>
      <Grid size={12}>
        {users && users.length > 0 ? (
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Fecha de creación</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Correo</TableCell>
                  {/* <TableCell>Acciones</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user: IUser) => (
                  <TableRow key={user.uid}>
                    <TableCell>{user.createdAt}</TableCell>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    {/* 
                    <TableCell>
                      <Tooltip title="Editar">
                        <IconButton
                          onClick={() => {
                            handleEdit(user);
                          }}
                        >
                          <span className="material-symbols-rounded">edit</span>
                        </IconButton>
                      </Tooltip>  <Tooltip title="Eliminar">
                        <IconButton
                          color="error"
                          onClick={() => handleShowConfirmation(user, "delete")}
                        >
                          <span className="material-symbols-rounded">
                            delete
                          </span>
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={
                          user.status === "enabled"
                            ? "Deshabilitar"
                            : "Habilitar"
                        }
                      >
                        <Switch
                          color="secondary"
                          size="small"
                          checked={user.status === "enabled"}
                          onChange={() =>
                            handleShowConfirmation(user, "disable")
                          }
                        />
                      </Tooltip>
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Alert
            severity="warning"
            action={
              <Button color="inherit" size="small" onClick={handleCreate}>
                Agregar
              </Button>
            }
          >
            No hay usuarios agregados
          </Alert>
        )}
      </Grid>

      {openModal.show && (
        <ModalConfirmation
          page="user"
          status={selectedUser.status}
          openModal={openModal}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
        />
      )}

      {open && <CreateUserModal show={open} handleClose={handleClose} />}
    </Grid>
  );
};

export default UserTable;
